import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Opportunity = _resolveComponent("Opportunity")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createBlock(_component_el_space, {
    size: 8,
    fill: "",
    "w-100": "",
    class: "App-Opportunities-List"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (opp, index) => {
        return (_openBlock(), _createBlock(_component_Opportunity, {
          opportunity: opp,
          key: `opp-${index}`
        }, null, 8, ["opportunity"]))
      }), 128))
    ]),
    _: 1
  }))
}